"use client";

import { useCallback } from "react";
import { useRouter } from "next/navigation";
import { useDispatch } from "react-redux";
import { setAppNotice } from "@/app/store/appShellSlice";
import { logoutAndReset } from "@/lib/logout";
import type { RootState } from "@/app/store/store";

type AppNotice = RootState["reparoly"]["appNotice"];

export function useAppNoticeHandler() {
  const router = useRouter();
  const dispatch = useDispatch();

  const clearNotice = useCallback(() => {
    dispatch(
      setAppNotice({
        open: false,
        message: "",
        title: "",
        details: "",
        errors: {},
        validationErrors: {},
        redirectTo: null,
      }),
    );
  }, [dispatch]);

  const handleNoticeAction = useCallback(
    async (notice: AppNotice | null | undefined) => {
      if (!notice) return;
      const action = notice.action || "";
      const redirect = notice.redirectTo || null;

      try {
        switch (action) {
          case "auth.sessionExpired": {
            await logoutAndReset({ dispatch });
            router.replace(redirect || "/auth");
            break;
          }
          default: {
            if (redirect) {
              router.push(redirect);
            }
            break;
          }
        }
      } catch {
        // Silenciar navegación fallida para no bloquear la limpieza de estado
      }
    },
    [dispatch, router],
  );

  return { handleNoticeAction, clearNotice };
}

export default useAppNoticeHandler;
